import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var OptionsToggle = function OptionsToggle(_a) {
  var selectedOption = _a.selectedOption,
    onOptionChange = _a.onOptionChange,
    optionsList = _a.optionsList;
  var divRef = useRef(null);
  var _b = useState(selectedOption || optionsList[0].value),
    currentOption = _b[0],
    setCurrentOption = _b[1];
  function handleOptionChange(newOption) {
    setCurrentOption(newOption);
    onOptionChange(newOption);
  }
  var handleOptionChangeRef = useRef(handleOptionChange);
  useEffect(function () {
    handleOptionChangeRef.current(selectedOption || optionsList[0].value);
  }, [optionsList, selectedOption]);
  useEffect(function () {
    if (divRef.current) {
      var currentSelection = optionsList.find(function (_a) {
        var value = _a.value;
        return value === currentOption;
      });
      var selectedButton = divRef.current.querySelector("[data-id=\"".concat(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.value, "\"]"));
      if (selectedButton) {
        var elementRect = selectedButton.getBoundingClientRect();
        var parentRect = divRef.current.getBoundingClientRect();
        var selectionIndicatorWidth = selectedButton.offsetWidth;
        var selectionIndicatorOffset = elementRect.left - parentRect.left;
        divRef.current.style.setProperty("--selection-indicator-width", "".concat(selectionIndicatorWidth, "px"));
        divRef.current.style.setProperty("--selection-indicator-offset", "".concat(selectionIndicatorOffset, "px"));
      }
    }
  }, [currentOption, optionsList]);
  var buttonDefaultClasses = classNames("active:bg-opacity-0 hover:bg-opacity-50", "text-sm shadow-sm px-md rounded-base cursor-pointer", "font-bold text-center", "inline-flex items-center relative h-full flex");
  var filterButtons = optionsList.map(function (option) {
    return /*#__PURE__*/React.createElement("button", {
      key: option.value,
      type: "button",
      "data-id": option.value,
      className: classNames(buttonDefaultClasses, {
        "bg-opacity-0": currentOption !== option.value
      }, {
        "opacity-25 cursor-default": option.disabled
      }, {
        "hover:bg-muted": !option.disabled && currentOption !== option.value
      }),
      onClick: function onClick() {
        return handleOptionChange(option.value);
      },
      disabled: option.disabled
    }, option.label);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "flex bg-light rounded-base relative h-3xl",
    ref: divRef,
    style: {
      padding: "2px",
      width: "fit-content"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex rounded-base absolute bg-white top-2px left-0 shadow-sm",
    style: {
      width: "var(--selection-indicator-width)",
      height: "calc(100% - 4px)",
      transition: "transform cubic-bezier(.2,.8,.3,.8) 300ms, width ease-out 300ms",
      transform: "translateX(var(--selection-indicator-offset))"
    }
  }), filterButtons);
};
OptionsToggle.propTypes = {
  selectedOption: PropTypes.string,
  onOptionChange: PropTypes.func.isRequired,
  optionsList: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    disabled: PropTypes.bool
  })).isRequired
};

export { OptionsToggle };
//# sourceMappingURL=index.es.js.map
